/**
 * Identifies the installation the application is running for, based on
 * `app.config.public.customer` (see the docker-compose-tomcat-*.yml files and
 * eua-auction-kubernetes/src/main/docker/tomcat/Dockerfile).
 */
export const EEX_CUSTOMER = 'European Energy Exchange AG';

export const AMPR_CUSTOMER = 'Amprion';

export const isEexCustomer = (customer) => customer === EEX_CUSTOMER;

export const isAmprCustomer = (customer) => customer === AMPR_CUSTOMER;
